import { render, staticRenderFns } from "./LaunchScreen.vue?vue&type=template&id=04cc4a77&scoped=true&"
import script from "./LaunchScreen.vue?vue&type=script&lang=js&"
export * from "./LaunchScreen.vue?vue&type=script&lang=js&"
import style0 from "./LaunchScreen.vue?vue&type=style&index=0&id=04cc4a77&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc4a77",
  null
  
)

export default component.exports